module.exports = __webpack_public_path__ + "static/media/block_icon_text.24bec98c.svg";